import React, { useState, useRef, useEffect } from 'react';
import './Footer.css';

// Modern brand icons (inline SVG)
const SocialIcon = ({ name }) => {
  const n = (name || '').toLowerCase();
  switch (n) {
    case 'linkedin':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor">
          <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 24h5V7.98H0V24zM8.12 7.98h4.78v2.17h.07c.66-1.25 2.28-2.57 4.69-2.57 5.02 0 5.95 3.3 5.95 7.58V24h-4.99v-6.79c0-1.62-.03-3.7-2.26-3.7-2.26 0-2.61 1.77-2.61 3.58V24H8.12V7.98z" />
        </svg>
      );
    case 'facebook':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor">
          <path d="M22.675 0h-21.35C.596 0 0 .596 0 1.333v21.334C0 23.404.596 24 1.325 24h11.495v-9.294H9.691V11.01h3.129V8.414c0-3.1 1.894-4.788 4.66-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.716-1.796 1.766v2.315h3.587l-.467 3.696h-3.12V24h6.116C23.404 24 24 23.404 24 22.667V1.333C24 .596 23.404 0 22.675 0z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.342 3.608 1.317.975.975 1.255 2.242 1.317 3.608.058 1.266.07 1.646.07 4.842s-.012 3.576-.07 4.842c-.062 1.366-.342 2.633-1.317 3.608-.975.975-2.242 1.255-3.608 1.317-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.342-3.608-1.317-.975-.975-1.255-2.242-1.317-3.608C2.175 15.76 2.163 15.38 2.163 12s.012-3.576.07-4.842c.062-1.366.342-2.633 1.317-3.608.975-.975 2.242-1.255 3.608-1.317C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.771.131 4.725.403 3.8 1.328c-.925.925-1.197 1.971-1.256 3.252C2.485 5.861 2.472 6.269 2.472 9.528v4.944c0 3.259.013 3.667.072 4.948.059 1.281.331 2.327 1.256 3.252.925.925 1.971 1.197 3.252 1.256C15.667.013 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z" />
        </svg>
      );
    default:
      return null;
  }
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    products: [
      { name: 'Surgical Scissors', href: '#products' },
      { name: 'Forceps & Clamps', href: '#products' },
      { name: 'Needle Holders', href: '#products' },
      { name: 'Retractors', href: '#products' },
      { name: 'Instrument Sets', href: '#products' }
    ],
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Mission', href: '#about' },
      { name: 'Quality Standards', href: '#about' },
      { name: 'Certifications', href: '#about' }
      // Careers removed
    ],
    support: [
      { name: 'Contact Us', href: '#contact' },
      { name: 'Technical Support', href: '#contact' },
      { name: 'Product Catalog', href: '#products' },
      { name: 'Warranty Info', href: '#contact' },
      { name: 'Shipping Info', href: '#contact' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: '#' },
      { name: 'Cookie Policy', href: '#' },
      { name: 'Compliance', href: '#' },
      { name: 'Returns Policy', href: '#' }
    ]
  };

  const socialLinks = [
    { name: 'LinkedIn', icon: 'linkedin', href: 'https://www.linkedin.com/company/oxgen-surgicals/' },
    { name: 'Facebook', icon: 'facebook', href: 'https://www.facebook.com/profile.php?id=61581554500225' },
    { name: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/oxgensurgicals/' }
  ];

  // Support and Legal informational content shown on click
  const supportContent = {
    'Contact Us': (
      <div>
        <p>We’re available 24/7 to assist you.</p>
        <p>
          WhatsApp: <a href="https://wa.me/923251422010" className="whatsapp-link" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +92 3251422010">+92 3251422010</a>
          <br />
          Email: <a href="mailto:oxgensurgicalsinfo@gmail.com" className="email-link">oxgensurgicalsinfo@gmail.com</a>
          <br />
          Sales: <a href="mailto:sales@oxgensurgicals.com" className="email-link">sales@oxgensurgicals.com</a>
        </p>
        <p>Location: Sialkot, Punjab, Pakistan</p>
      </div>
    ),
    'Technical Support': (
      <div>
        <p>For technical assistance with instruments or orders, contact our support team 24/7.</p>
        <ul>
          <li>Email: <a href="mailto:oxgensurgicalsinfo@gmail.com" className="email-link">oxgensurgicalsinfo@gmail.com</a></li>
          <li>Sales: <a href="mailto:sales@oxgensurgicals.com" className="email-link">sales@oxgensurgicals.com</a></li>
          <li>WhatsApp: <a href="https://wa.me/923251422010" className="whatsapp-link" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +92 3251422010">+92 3251422010</a></li>
          <li>Please include the instrument name, serial/lot number, and a brief description of the issue.</li>
        </ul>
      </div>
    ),
    'Product Catalog': (
      <div>
        <p>Explore our full range of products and instrument sets.</p>
        <ul>
          <li>
            Browse online: <a href="/products">Products</a>
          </li>
          <li>
            Download catalog: <a href="/Oxgen%20Surgicals.pdf" target="_blank" rel="noopener noreferrer">Oxgen Surgicals (PDF)</a>
          </li>
        </ul>
      </div>
    ),
    'Warranty Info': (
      <div>
        <p>Oxgen Surgicals instruments are covered against manufacturing defects.</p>
        <ul>
          <li>Standard warranty: 12 months from delivery date (unless specified otherwise).</li>
          <li>Coverage: Manufacturing defects and workmanship issues.</li>
          <li>Exclusions: Misuse, improper sterilization, accidental damage, and normal wear.</li>
          <li>To claim: Contact support with proof of purchase and product details.</li>
        </ul>
      </div>
    ),
    'Shipping Info': (
      <div>
        <p>We ship worldwide with reliable carriers.</p>
        <ul>
          <li>Dispatch time: Typically 2–5 business days after order confirmation.</li>
          <li>Tracking: Provided via email once shipped.</li>
          <li>International: Customs duties and taxes are the responsibility of the receiver.</li>
        </ul>
      </div>
    )
  };

  const legalContent = {
    'Privacy Policy': (
      <div>
        <p>We respect your privacy. We collect only the necessary information to process orders and support inquiries.</p>
        <ul>
          <li>Data collected: Contact details, order information, and correspondence.</li>
          <li>Usage: Order fulfillment, customer support, and service improvements.</li>
          <li>Storage: Secured and retained only as long as necessary.</li>
          <li>Contact: For privacy requests, email oxgensurgicalsinfo@gmail.com or sales@oxgensurgicals.com.</li>
        </ul>
      </div>
    ),
    'Terms of Service': (
      <div>
        <p>By ordering from Oxgen Surgicals, you agree to our terms of sale and use.</p>
        <ul>
          <li>Orders: Subject to availability and confirmation.</li>
          <li>Payments: As agreed with the customer; orders may be held until payment is received.</li>
          <li>Warranty & returns: See Warranty Info and Returns Policy for details.</li>
          <li>Liability: Limited to repair or replacement as appropriate.</li>
        </ul>
      </div>
    ),
    'Cookie Policy': (
      <div>
        <p>Our website uses essential and performance cookies to improve user experience.</p>
        <ul>
          <li>Essential: Required for basic site functionality.</li>
          <li>Performance: Helps us understand usage to improve the site.</li>
          <li>Control: You may adjust cookie settings through your browser.</li>
        </ul>
      </div>
    ),
    Compliance: (
      <div>
        <p>We follow applicable international quality and safety standards.</p>
        <ul>
          <li>Manufacturing: Quality-controlled processes and materials.</li>
          <li>Documentation: Certificates provided upon request where applicable.</li>
        </ul>
      </div>
    ),
    'Returns Policy': (
      <div>
        <p>We aim for complete satisfaction with every purchase.</p>
        <ul>
          <li>Eligibility: Unused products in original condition and packaging.</li>
          <li>Process: Request an RMA via support within 30 days of delivery.</li>
          <li>Inspection: Items are inspected before refund or replacement.</li>
          <li>Fees: A restocking fee may apply depending on the item condition.</li>
        </ul>
      </div>
    )
  };

  const [selectedInfo, setSelectedInfo] = useState(null);

  const handleInfoClick = (group, name, e) => {
    if (e) e.preventDefault();
    const contentMap = group === 'support' ? supportContent : legalContent;
    const content = contentMap[name];
    if (content) {
      setSelectedInfo({ group, title: name, content });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const infoPanelRef = useRef(null);
  useEffect(() => {
    if (selectedInfo && infoPanelRef.current) {
      infoPanelRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedInfo]);

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <div className="brand-logo">
                <h3>Oxgen Surgicals</h3>
                <span className="brand-tagline">Premium Medical Equipment</span>
              </div>
              <p className="brand-description">
                Leading manufacturer of high-quality surgical instruments, 
                serving healthcare professionals worldwide with precision, 
                reliability, and innovation.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.href}
                    className="social-link"
                    aria-label={social.name}
                    title={social.name}
                  >
                    <span className="social-icon"><SocialIcon name={social.icon} /></span>
                  </a>
                ))}
              </div>
            </div>

            <div className="footer-links">
              <div className="link-group">
                <h4>Products</h4>
                <ul>
                  {footerLinks.products.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4>Company</h4>
                <ul>
                  {footerLinks.company.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4>Support</h4>
                <ul>
                  {footerLinks.support.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} onClick={(e) => handleInfoClick('support', link.name, e)}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4>Legal</h4>
                <ul>
                  {footerLinks.legal.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} onClick={(e) => handleInfoClick('legal', link.name, e)}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="footer-contact">
              <h4>Get In Touch</h4>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <div>
                  <p>Sialkot</p>
                  <p>Punjab</p>
                  <p>Pakistan</p>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <div>
                  <p className="contact-phone-row">
                    <a href="https://wa.me/923251422010" className="whatsapp-link" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +92 3251422010">WhatsApp: +92 3251422010</a>
                  </p>
                  <p>Available 24/7</p>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <div>
                  <p>
                    <a href="mailto:oxgensurgicalsinfo@gmail.com" className="email-link">oxgensurgicalsinfo@gmail.com</a>
                     <br />
                     <a href="mailto:sales@oxgensurgicals.com" className="email-link">sales@oxgensurgicals.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {selectedInfo && (
            <div className="footer-info-panel" role="region" aria-live="polite" aria-label={`${selectedInfo.group} information`} ref={infoPanelRef}>
              <div className="info-header">
                <h4 className="info-title">{selectedInfo.title}</h4>
                <button className="info-close" onClick={() => setSelectedInfo(null)} aria-label="Close information">×</button>
              </div>
              <div className="info-content">{selectedInfo.content}</div>
            </div>
          )}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Oxgen Surgicals. All rights reserved.</p>
            </div>
            <div className="footer-bottom-links">
              <a href="#" onClick={(e) => handleInfoClick('legal', 'Privacy Policy', e)}>Privacy Policy</a>
              <a href="#" onClick={(e) => handleInfoClick('legal', 'Terms of Service', e)}>Terms of Service</a>
            </div>
            <button 
               className="back-to-top"
               onClick={scrollToTop}
               aria-label="Back to top"
             >
               <span className="back-to-top-icon">↑</span>
             </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;